import {
  LocationMissingData,
  LocationMissingDataType,
} from '@vgrubs/components';

/**
 * Where a missing item gets fixed from Location Details: Bank Details (which
 * also takes the voided check), the owner's profile, or nowhere in the admin.
 */
export type MissingDataAction = 'bankDetails' | 'ownerProfile' | null;

type Guide = {
  /** A chip's few words; the backend's own title is a whole sentence. */
  label: string;
  /** Where it gets added, and by whom - the chip's tooltip. */
  hint: string;
  action: MissingDataAction;
};

const GUIDE: Record<LocationMissingDataType, Guide> = {
  voidCheck: {
    label: 'No voided check',
    hint: 'Upload it in Bank Details.',
    action: 'bankDetails',
  },
  bankAccountLast4: {
    label: 'No bank last 4',
    hint: 'Add it in Bank Details.',
    action: 'bankDetails',
  },
  einLast4: {
    label: 'No EIN last 4',
    hint: 'Add it in Bank Details.',
    action: 'bankDetails',
  },
  // The owner uploads it at sign up and replaces it from Settings; the admin
  // only shows it.
  businessLicense: {
    label: 'No business license',
    hint: 'The owner uploads it from Settings in the merchant app.',
    action: null,
  },
  payoutBank: {
    label: 'No payout bank',
    hint: "Connect one on the owner's profile.",
    action: 'ownerProfile',
  },
  ownerEmail: {
    label: 'No owner email',
    hint: "Add one on the owner's profile.",
    action: 'ownerProfile',
  },
};

/**
 * A type this build does not know yet (the backend adding one) still shows,
 * with the backend's title and no action, rather than breaking the alert.
 */
export const missingDataGuide = (item: LocationMissingData): Guide =>
  GUIDE[item.type] ?? { label: item.title, hint: '', action: null };
